import useSWR from 'swr';
import { regulatoryService } from 'services';
import { useAuth } from 'hooks';
import { Header, Loading, Main } from 'components';
import { RegulatoryForm } from './components';

export function RegulatoryInformationPage() {
  const { selectedStore } = useAuth();
  const { name: store } = selectedStore;

  const { data, isLoading } = useSWR(
    `regulatory-${store}`,
    () => regulatoryService.getForm({ store }),
    { revalidateOnFocus: false }
  );

  if (!data) {
    return;
  }

  return (
    <Main>
      <Header />

      {isLoading ? (
        <Loading />
      ) : (
        <RegulatoryForm initialValues={data} store={store || ''} />
      )}
    </Main>
  );
}
